// @ts-nocheck
(function () {
  var hasHover = window.matchMedia('(hover: hover)').matches;

  function closeAllCards(except) {
    document.querySelectorAll('.product-tab-card--subscription.is-active').forEach(function (c) {
      if (c !== except) c.classList.remove('is-active');
    });
  }

  function initSubscriptionCards() {
    document.querySelectorAll('.product-tab-card--subscription').forEach(function (card) {
      var qtyContainer = card.querySelector('.product-tab-card__qty');
      var addBtn = card.querySelector('.product-tab-card__add-btn');

      if (!qtyContainer || !addBtn) return;
      if (card.dataset.subscriptionInit) return;
      card.dataset.subscriptionInit = 'true';

      var valueEl = qtyContainer.querySelector('.product-tab-card__qty-value');
      var decBtn = qtyContainer.querySelector('.dec');
      var incBtn = qtyContainer.querySelector('.inc');

      decBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var current = parseInt(valueEl.textContent, 10) || 1;
        if (current > 1) {
          valueEl.textContent = current - 1;
        }
      });

      incBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var current = parseInt(valueEl.textContent, 10) || 1;
        valueEl.textContent = current + 1;
      });

      var frequencySelect = card.querySelector('.product-tab-card__frequency-select');

      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = addBtn.dataset.variantId;
        var quantity = parseInt(valueEl.textContent, 10) || 1;
        var originalText = addBtn.textContent;

        var properties = {};
        if (frequencySelect) {
          var selectedOption = frequencySelect.options[frequencySelect.selectedIndex];
          properties['_frequency'] = selectedOption.value;
          properties['Frequencia da Assinatura'] = selectedOption.text;
          properties['_subscription'] = 'clube';
        }

        addBtn.disabled = true;
        addBtn.textContent = 'Adicionando...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: Number(variantId),
              quantity: quantity,
              properties: properties
            }]
          })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Erro ao adicionar produto');
            return res.json();
          })
          .then(function () {
            return fetch('/cart.js').then(function (res) { return res.json(); });
          })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                data: { itemCount: cart.item_count }
              }
            }));

            valueEl.textContent = '1';
            addBtn.textContent = 'Adicionado!';

            setTimeout(function () {
              addBtn.textContent = originalText;
              addBtn.disabled = false;
            }, 2000);
          })
          .catch(function () {
            addBtn.textContent = originalText;
            addBtn.disabled = false;
            alert('Erro ao adicionar produto ao carrinho. Tente novamente.');
          });
      });

      if (!hasHover) {
        var mediaEl = card.querySelector('.product-tab-card__media');
        if (mediaEl) {
          mediaEl.addEventListener('click', function (e) {
            if (e.target.closest('.product-tab-card__actions')) return;

            e.preventDefault();
            var isOpen = card.classList.contains('is-active');
            closeAllCards();
            if (!isOpen) {
              card.classList.add('is-active');
            }
          });
        }
      }
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.product-tab-card--subscription')) {
      closeAllCards();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSubscriptionCards);
  } else {
    initSubscriptionCards();
  }
})();
